/**
 * AMOXTLI - Theme System & Color Definitions
 * 
 * Propiedad Intelectual: Soluciones TecnoExpertas SAPI de CV
 * Autor: Luis Alberto Orozco Arias
 * Licencia: Propietaria - Todos los derechos reservados © 2026
 * 
 * Descripción: 4 temas disponibles con paleta oficial Azul Profundo + Turquesa
 * Tema oficial: Azul Profundo #0A2A43, Turquesa #00C2C7, Blanco #FFFFFF, Gris #A7B0B7
 */

export const THEMES = {
  amoxtli: {
    id: 'amoxtli',
    name: 'AMOXTLI',
    description: 'Tema oficial AMOXTLI - Registro, criterio e inteligencia fiscal',
    colors: {
      primary: '#0A2A43',
      primaryLight: '#1a3a57',
      primaryDark: '#051a2f',
      secondary: '#00C2C7',
      secondaryLight: '#4dd6db',
      secondaryDark: '#0099a0',
      background: 'from-slate-50 via-blue-50 to-slate-100',
      surface: 'bg-white',
      surfaceAlt: 'bg-slate-50',
      text: 'text-slate-900',
      textMuted: 'text-slate-600',
      gradient: 'from-blue-900 to-cyan-500',
      button: 'bg-blue-900 hover:bg-blue-950 text-white',
      buttonSecondary: 'bg-cyan-500 hover:bg-cyan-600 text-white',
      border: 'border-blue-200',
      input: 'bg-white border-blue-200 focus:ring-blue-900 focus:border-blue-900',
    },
    tailwind: {
      header: 'bg-white shadow-sm border-b border-blue-200',
      sidebar: 'bg-gradient-to-b from-blue-50 to-cyan-50',
      card: 'bg-white border border-blue-200 shadow-sm hover:shadow-md',
      button: 'bg-blue-900 hover:bg-blue-950 text-white',
      buttonOutline: 'border-2 border-blue-900 text-blue-900 hover:bg-blue-50',
      input: 'border-blue-300 focus:ring-blue-900 focus:border-blue-900',
      badge: 'bg-blue-100 text-blue-900',
      link: 'text-blue-900 hover:text-cyan-600',
      title: 'text-blue-900',
      subtitle: 'text-blue-700',
      buttonPrimary: 'bg-blue-900 hover:bg-blue-950 text-white',
    }
  },
  blueGreen: {
    id: 'blueGreen',
    name: 'Azul & Verde',
    description: 'Tema claro con tonos azul y verde',
    colors: {
      primary: '#3b82f6',
      primaryLight: '#dbeafe',
      primaryDark: '#1e40af',
      secondary: '#10b981',
      secondaryLight: '#d1fae5',
      secondaryDark: '#047857',
      background: 'from-blue-50 via-emerald-50 to-blue-100',
      surface: 'bg-white',
      surfaceAlt: 'bg-blue-50',
      text: 'text-slate-900',
      textMuted: 'text-slate-600',
      gradient: 'from-blue-500 to-emerald-500',
      button: 'bg-blue-600 hover:bg-blue-700 text-white',
      buttonSecondary: 'bg-emerald-600 hover:bg-emerald-700 text-white',
      border: 'border-blue-200',
      input: 'bg-white border-blue-200 focus:ring-blue-500 focus:border-blue-500',
    },
    tailwind: {
      header: 'bg-white shadow-sm border-b border-blue-200',
      sidebar: 'bg-gradient-to-b from-blue-50 to-emerald-50',
      card: 'bg-white border border-blue-200 shadow-sm hover:shadow-md',
      button: 'bg-blue-600 hover:bg-blue-700 text-white',
      buttonOutline: 'border-2 border-blue-600 text-blue-600 hover:bg-blue-50',
      input: 'border-blue-300 focus:ring-blue-500 focus:border-blue-500',
      badge: 'bg-blue-100 text-blue-800',
      link: 'text-blue-600 hover:text-blue-800',
      title: 'text-blue-900',
      subtitle: 'text-blue-700',
      buttonPrimary: 'bg-blue-600 hover:bg-blue-700 text-white',
    }
  },
  purplePink: {
    id: 'purplePink',
    name: 'Púrpura & Rosa',
    description: 'Tema elegante con tonos púrpura y rosa',
    colors: {
      primary: '#a855f7',
      primaryLight: '#f3e8ff',
      primaryDark: '#7e22ce',
      secondary: '#ec4899',
      secondaryLight: '#fce7f3',
      secondaryDark: '#be185d',
      background: 'from-purple-50 via-pink-50 to-purple-100',
      surface: 'bg-white',
      surfaceAlt: 'bg-purple-50',
      text: 'text-slate-900',
      textMuted: 'text-slate-600',
      gradient: 'from-purple-500 to-pink-500',
      button: 'bg-purple-600 hover:bg-purple-700 text-white',
      buttonSecondary: 'bg-pink-600 hover:bg-pink-700 text-white',
      border: 'border-purple-200',
      input: 'bg-white border-purple-200 focus:ring-purple-500 focus:border-purple-500',
    },
    tailwind: {
      header: 'bg-white shadow-sm border-b border-purple-200',
      sidebar: 'bg-gradient-to-b from-purple-50 to-pink-50',
      card: 'bg-white border border-purple-200 shadow-sm hover:shadow-md',
      button: 'bg-purple-600 hover:bg-purple-700 text-white',
      buttonOutline: 'border-2 border-purple-600 text-purple-600 hover:bg-purple-50',
      input: 'border-purple-300 focus:ring-purple-500 focus:border-purple-500',
      badge: 'bg-purple-100 text-purple-800',
      link: 'text-purple-600 hover:text-purple-800',
      title: 'text-purple-900',
      subtitle: 'text-purple-700',
      buttonPrimary: 'bg-purple-600 hover:bg-purple-700 text-white',
    }
  },
  orangeTeal: {
    id: 'orangeTeal',
    name: 'Naranja & Teal',
    description: 'Tema vibrante con tonos naranja y teal',
    colors: {
      primary: '#f97316',
      primaryLight: '#fed7aa',
      primaryDark: '#b45309',
      secondary: '#14b8a6',
      secondaryLight: '#ccfbf1',
      secondaryDark: '#0d9488',
      background: 'from-orange-50 via-teal-50 to-orange-100',
      surface: 'bg-white',
      surfaceAlt: 'bg-orange-50',
      text: 'text-slate-900',
      textMuted: 'text-slate-600',
      gradient: 'from-orange-500 to-teal-500',
      button: 'bg-orange-600 hover:bg-orange-700 text-white',
      buttonSecondary: 'bg-teal-600 hover:bg-teal-700 text-white',
      border: 'border-orange-200',
      input: 'bg-white border-orange-200 focus:ring-orange-500 focus:border-orange-500',
    },
    tailwind: {
      header: 'bg-white shadow-sm border-b border-orange-200',
      sidebar: 'bg-gradient-to-b from-orange-50 to-teal-50',
      card: 'bg-white border border-orange-200 shadow-sm hover:shadow-md',
      button: 'bg-orange-600 hover:bg-orange-700 text-white',
      buttonOutline: 'border-2 border-orange-600 text-orange-600 hover:bg-orange-50',
      input: 'border-orange-300 focus:ring-orange-500 focus:border-orange-500',
      badge: 'bg-orange-100 text-orange-800',
      link: 'text-orange-600 hover:text-orange-800',
      title: 'text-orange-900',
      subtitle: 'text-orange-700',
      buttonPrimary: 'bg-orange-600 hover:bg-orange-700 text-white',
    }
  }
}

export const DEFAULT_THEME = THEMES.amoxtli.id

export const getTheme = (themeId) => {
  return THEMES[themeId] || THEMES[DEFAULT_THEME]
}

export const getThemeList = () => {
  return Object.values(THEMES).map(theme => ({
    id: theme.id,
    name: theme.name,
    description: theme.description
  }))
}
